/** PayHere recurring needs Premium / tokenization enabled on the merchant account. */
export const PAYHERE_RECURRING_ENABLED =
  process.env.REACT_APP_PAYHERE_RECURRING === "true";
